import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import firebase from 'firebase/app';
import 'firebase/firestore';

const state = {
  workspace: null,
  loading: false,
};

const mutations = {
  load_workspace_active(state, data) {
    state.loading = data;
  },
  set_workspace(state, data) {
    state.workspace = data;
  },
};

const actions = {
  load_workspace: async ({ commit }, payload) => {
    commit('load_workspace_active', payload);
  },
  get_existing_workspace: async ({ commit }, payload) => {
    try {
      const workspaceRef = firebase
        .firestore()
        .collection('organizations')
        .doc(payload);

      return await (await workspaceRef.get()).data();
    } catch (error) {
      // handle error
    }
  },
  get_existing_workspaces_by_scac: async ({ commit }, payload) => {
    try {
      const workspaceRef = await firebase
        .firestore()
        .collection('organizations')
        .where('scac', '==', payload)
        .get();
      const workspaces = workspaceRef.docs.map((doc) => doc.data());
      return workspaces;
    } catch (error) {}
  },
  set_workspace: async ({ commit }, payload) => {
    try {
      const workspaceRef = firebase
        .firestore()
        .collection('organizations')
        .doc(payload);
      const workspaceData = await (await workspaceRef.get()).data();

      commit('set_workspace', workspaceData);
    } catch (error) {
      commit('set_workspace', []);
    }
  },

  get_agent_invitations: async ({ commit }, payload) => {
    try {
      const { orgId, scac, email } = payload;
      const { docs: inviteData } = await firebase
        .firestore()
        .collection('invitations')
        .where('agency_org', '==', orgId)
        .where('email', '==', email)
        .where('scac', '==', scac)
        .get();

      return inviteData;
    } catch (error) {
      // console.log('er')
    }
  },
  // Sending invitation when agent register to the app
  send_invitation_to_agency: async ({ commit }, payload) => {
    try {
      const { scac, orgId, email: agentEmail } = payload;
      const orgRef = firebase
        .firestore()
        .collection('organizations')
        .doc(orgId);

      await orgRef.update({
        pending_agent_verifications:
          firebase.firestore.FieldValue.arrayUnion(scac),
      });

      const pendingVerificationRef = await firebase
        .firestore()
        .collection('pending_verifications')
        .where('email', '==', agentEmail)
        .get();

      const verification = pendingVerificationRef.docs[0];

      await verification.ref.update({
        agency_verification: 'pending',
        agencyOrgId: orgId,
      });
      localStorage.setItem('agency_verification', 'pending');

      const { email, company } = (await orgRef.get()).data();

      if (verification?.exists) {
        const data = verification.data();

        // sending email to agency
        await firebase
          .firestore()
          .collection('mail')
          .add({
            to: email,
            template: {
              name: 'agent_activity',
              data: {
                created: getLocalTime().format('MM/DD/YYYY'),
                scac: data.scac,
                company: data.company,
                type: data.org_type,
                title: `Hello ${company}, You are invited to accept/decline the invitation from ${data.company}.`,
                url: `${process.env.VUE_APP_CANONICAL_URL}/settings?page=organization`,
              },
            },
          });

        // sending email to agent
        await firebase
          .firestore()
          .collection('mail')
          .add({
            to: data.email,
            template: {
              name: 'agent_activity',
              data: {
                created: getLocalTime().format('MM/DD/YYYY'),
                scac: data.scac,
                company: data.company,
                type: data.org_type,
                title: `Hello ${data.company},You are requesting ${company} to accept/decline the invitation`,
                url: `${process.env.VUE_APP_CANONICAL_URL}/agent-verify`,
              },
            },
          });
      }
    } catch (error) {
      // handle error
      console.log('error', error);
    }
  },
};

const getters = {
  get_load_workspace_active(state) {
    return state.loading;
  },
  get_workspace(state) {
    return state.workspace;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
